import { ValueProperty } from '../common/index';
import * as React from 'react';
import { ComponentProps, SingleKeyValueComponent, NoValueDash } from '../common';
import styles from './display-child-values.scss';
import { Expandable, standardTextLimit, ShouldTruncate } from 'ui/expandable';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';

export class DisplayChildValues extends React.Component<DisplayChildValuesProps<any>, DisplayChildValuesState> {
  public static getDerivedStateFromProps(props:DisplayChildValuesProps<any>) {
    const {childValues = [], separator = ', '} = props;
    const displayValues = childValues.filter(child => child && child.valueItem && !!child.valueItem.value);

    const items:string[] = displayValues.map((child, i) => {
      const separatorString = (displayValues.length > 1 && i < displayValues.length - 1 ) ? separator : '';
      return `${child.valueItem.description || child.valueItem.value}${separatorString}`;
    });

    let accumulated: number = 0;
    const truncatedItems = items.map(item => {
      const delta = standardTextLimit - accumulated;
      accumulated = item.length;
      if (delta < 0) {
        return null;
      }
      return item.length < delta ? item : item.substr(0, delta) + '...';
    }).filter(item => item);

    return {items, truncatedItems};
  }

  public state:Readonly<DisplayChildValuesState> = {
    items: [],
    truncatedItems: []
  };

  private renderListItems = (displayValues: string[]) => {
    return displayValues.map((value: string, index) => <span className={`${styles.item} item-value`} key={index}>
        {insertOptionalWordbreaks(value)}{'\u200B'}
      </span>);
  };

  private expanderRender = (collapsed: boolean) => {
    const {items, truncatedItems} = this.state;
    if (!collapsed) {
      return this.renderListItems(items);
    }
    return this.renderListItems(truncatedItems);
  };

  public render() {
    const {
      componentId,
      className,
      label,
      hideIfNoValues = false,
      textDisplayMore,
      textDisplayLess,
      shouldTruncate = false
    } = this.props;

    const {items} = this.state;
    const labelText = (label && label.visible !== false) && label.text;
    const doTruncate = shouldTruncate && ShouldTruncate(items.join(''));

    if(hideIfNoValues && !items.length)  {
      return null;
    }

    return (
        <div id={componentId} className={`${styles.separatedValues} ${className}`}>
          {labelText && <label className="label">{labelText}</label>}
            {items.length ?
              <div className={styles.wrapper}>
                {doTruncate ? <Expandable
                  content={this.expanderRender}
                  {...{textDisplayLess, textDisplayMore}}/>
                :
                  this.renderListItems(items)
                }
              </div>
              : <NoValueDash/>
            }
        </div>
    );
  }
}

interface DisplayChildValuesState {
  items: string[];
  truncatedItems: string[];
}

export interface DisplayChildValuesProps<T extends ValueProperty> extends ComponentProps{
  childValues: SingleKeyValueComponent<T>[];
  separator?: string;
  hideIfNoValues?: boolean;
  textDisplayMore?: string;
  textDisplayLess?: string;
  shouldTruncate?: boolean;
}
